import React from 'react';

interface LogoProps {
  className?: string;
  size?: 'sm' | 'md' | 'lg';
  showText?: boolean;
}

export function Logo({ className = '', size = 'md', showText = true }: LogoProps) {
  const sizeClasses = {
    sm: 'h-6 w-6',
    md: 'h-8 w-8', 
    lg: 'h-12 w-12'
  };

  const textSizeClasses = {
    sm: 'text-lg',
    md: 'text-xl',
    lg: 'text-2xl'
  };

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* Logo Icon */}
      <div className={`${sizeClasses[size]} flex-shrink-0`}>
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 32 32" 
          className="w-full h-full"
        >
          <defs>
            <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" style={{stopColor:'#10b981', stopOpacity:1}} />
              <stop offset="100%" style={{stopColor:'#059669', stopOpacity:1}} />
            </linearGradient>
          </defs>
          
          {/* Background circle */}
          <circle cx="16" cy="16" r="14" fill="url(#logoGrad)" stroke="#047857" strokeWidth="2"/>
          
          {/* Rocket/D deployment symbol */}
          <path d="M8 12 L16 8 L24 12 L24 20 L16 24 L8 20 Z" fill="white" opacity="0.9"/>
          <path d="M12 14 L12 18 L20 18 L20 14 Z" fill="#10b981"/>
          
          {/* Deployment arrows */}
          <path d="M16 6 L14 8 L16 10 L18 8 Z" fill="white" opacity="0.8"/>
          <path d="M16 22 L14 24 L16 26 L18 24 Z" fill="white" opacity="0.8"/>
          <path d="M6 16 L8 14 L10 16 L8 18 Z" fill="white" opacity="0.8"/>
          <path d="M22 16 L24 14 L26 16 L24 18 Z" fill="white" opacity="0.8"/>
        </svg>
      </div>

      {/* Logo Text */}
      {showText && (
        <div className="flex flex-col">
          <span className={`font-bold bg-gradient-to-r from-emerald-500 to-emerald-600 bg-clip-text text-transparent ${textSizeClasses[size]}`}>
            DeployPro
          </span>
          {size === 'lg' && (
            <span className="text-xs text-slate-500 -mt-1">
              Deploy Your Apps Like a Pro
            </span>
          )}
        </div>
      )}
    </div>
  );
}
